import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSavedCards, processPayment, saveCard, createSetupIntent, } from "../../core/data/redux/actions/StripeCardActions";
import StripeCard, { StripeCardHandle } from "../payment/save-card";
import { AppDispatch, RootState } from "../../core/data/redux/store";
import Lottie from "lottie-react";
import Loader from "../../core/data/img/car_loading.json";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { toast, ToastContainer } from "react-toastify";
import { getPaymentAccount, addPaymentAccount, manualPayment, resetPaymentAccount, otherPayment, } from "../../core/data/redux/action";
import "react-toastify/dist/ReactToastify.css";
import "../../index.css"



const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '');

const BookingPayment = (bookingInfo: any,) => {


  const dispatch = useDispatch<AppDispatch>();
  const { loading, savedCards = [], clientSecret: reduxClientSecret, error: paymentError } = useSelector((state: any) => state.stripeCard);
  const [selectedCard, setSelectedCard] = useState<string | null>(null);
  const [newCard, setNewCard] = useState(false);
  const [paymentType, setPaymentType] = useState("card");
  const [Error, setError] = useState<boolean>(false);
  const stripeCardRef = useRef<StripeCardHandle>(null);

  const { manualPaymentError, otherPaymentLoading, otherPaymentError, otherPaymentSuccess, savePayoutAccountError, savedData, manualPaymentSuccess, payoutAccountList, bookingTotalAmount, bookingsSuccess } = useSelector(
    (state: RootState) => ({
      bookingsSuccess: state.booking.bookingsSuccess,
      bookingTotalAmount: state.booking.bookingTotalAmount,
      payoutAccountList: state.payout.payoutAccountList,
      // savePayoutAccountSuccess: state.payout.savePayoutAccountSuccess,
      savedData: state.payout.savedData,
      savePayoutAccountError: state.payout.savePayoutAccountError,
      otherPaymentLoading: state.payout.otherPaymentLoading,
      otherPaymentError: state.payout.otherPaymentError,
      otherPaymentSuccess: state.payout.otherPaymentSuccess,
      manualPaymentSuccess: state.payout.manualPaymentSuccess,
      manualPaymentError: state.payout.manualPaymentError,


    })
  );

  const initialPayment = bookingInfo?.bookings?.cost_summary?.initialPayment ?? bookingTotalAmount?.initialPayment;

  const closeModal = () => {
    const modalElement = document.getElementById("make_payment");
 
 
    if (modalElement) {
       modalElement.classList.remove("show"); 
    }

    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";

  };

  useEffect(() => {
    if (manualPaymentSuccess || otherPaymentSuccess) {
      closeModal();
    }

  }, [manualPaymentSuccess, otherPaymentSuccess]);


  useEffect(() => {
    dispatch(fetchSavedCards());
  }, [dispatch]);

  useEffect(() => {
    if (paymentType === 'card') {
      dispatch(createSetupIntent());
    }
  }, [newCard, dispatch]);


  useEffect(() => {

    if (paymentType !== 'card') {
      setError(false);
      setSelectedCard("");
      setSelectedCashID("");
      setSelectedZelleIdentifier("");
      dispatch(getPaymentAccount({ "payment_method": paymentType }))
    }

  }, [paymentType]);



  useEffect(() => {
    if (savedData && paymentType !== 'card') {
      dispatch(manualPayment({
        "booking_id": bookingInfo.bookings?.id,
        "payout_account_id": savedData?.id
      }))

      dispatch(resetPaymentAccount());
    }
  }, [savedData]);



  useEffect(() => {


    if (paymentError || savePayoutAccountError || otherPaymentError || manualPaymentError) {
      setToastMessage('');
      showToast(paymentError || savePayoutAccountError || otherPaymentError || manualPaymentError);
    }

    if (manualPaymentSuccess || otherPaymentSuccess) {

      dispatch(resetPaymentAccount());
      setToastMessage('');
      showToast(manualPaymentSuccess || otherPaymentSuccess);

    }

  }, [savePayoutAccountError, paymentError, manualPaymentSuccess, otherPaymentError, otherPaymentSuccess, manualPaymentError]);

  const handleAddNewCard = () => {
    setSelectedCard(null);
    setNewCard(true);
  };

  const handleUseCard = async () => {
    if (!selectedCard && !newCard) {
      return alert("Please select a card or add a new one.");
    }

    try {
      if (selectedCard) {
        await dispatch(processPayment(bookingInfo.bookings?.id, selectedCard));

      } else if (newCard && stripeCardRef.current) {
        const success = await stripeCardRef.current.handlePayment();
        if (!success) {

          toast.error("Failed to create payment method", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
          });

          return;
        }
      }
    } catch (err: any) {

      setToastMessage('');
      showToast(err?.message || "Payment failed");



    }
  };

  const onCardSaved = async (paymentMethodId: string) => {
    try {

      await dispatch(saveCard(paymentMethodId, (savedId) => {
        setNewCard(false);
        setSelectedCard(savedId);
      }));


      await dispatch(processPayment(bookingInfo.bookings?.id, paymentMethodId));

    } catch (err: any) {
      setToastMessage('');
      showToast(err?.message || "Payment failed");



    }
  };

  // useEffect(() => {
  //   console.log("New Card State Updated:", newCard, "Triggered by:", new Error().stack);
  // }, [newCard]);

  // useEffect(() => {
  //   console.log("Select card State Updated:", selectedCard);
  // }, [selectedCard]);



  const [selectedCashID, setSelectedCashID] = useState("");
  const [selectedZelleIdentifier, setSelectedZelleIdentifier] = useState("");
  const [customerNotes, setCustomerNotes] = useState("");

  // const [referenceId, setReferenceId] = useState("");
  // const [cashtags, setCashtags] = useState(["@john_capp", "@family_fund"]);


  const handleConfirm = () => {

    if (paymentType === "cashapp" && selectedCashID) {
      dispatch(addPaymentAccount({
        "payment_method": paymentType,
        "cashapp_id": selectedCashID,
      }))

    } else if (paymentType === "zelle" && selectedZelleIdentifier) {
      dispatch(addPaymentAccount({
        "payment_method": paymentType,
        "zelle_identifier": selectedZelleIdentifier
      }))


    } else {

      if (selectedCard) {
        dispatch(manualPayment({
          "booking_id": bookingInfo.bookings?.id,
          "payout_account_id": selectedCard
        }))

      } else {
        setError(true);
        setToastMessage('');
        showToast("The payout account id field is required");


      }
    }

  };

  const handlePaylater = () => {

    if (customerNotes) {
      dispatch(otherPayment({
        "booking_id": bookingInfo.bookings?.id,
        "customer_notes": customerNotes
      }))

    } else {
      setError(true);
      setToastMessage('');
      showToast("The customer notes field is required.");

    }
  }

  const [toastMessage, setToastMessage] = useState('');
  const [toastClass, setToastClass] = useState('bg-success text-white');



  const showToast = (message: any) => {
    setToastClass(paymentError || savePayoutAccountError || otherPaymentError || manualPaymentError || Error ? 'bg-danger text-white' : 'bg-success text-white')

    setToastMessage(message);
  };


  const handleCloseToast = () => {
    setToastMessage('');

  };


  useEffect(() => {
    if (toastMessage) {
      if (toastClass === 'bg-danger text-white') {
        toast.error(toastMessage, { position: "top-right", hideProgressBar: true, onClose: handleCloseToast, progress: undefined, toastId: "", })
      } else {
        toast.success(toastMessage, { position: "top-right", hideProgressBar: true, onClose: handleCloseToast, progress: undefined, toastId: "", })
      }

    }
  }, [toastMessage, toastClass]);



 

  return (
    <div>
 
      {/* {toastMessage && (
        <>
          {toastClass === 'bg-danger text-white'
            ? toast.error(toastMessage, { position: "top-right", hideProgressBar: true, onClose: handleCloseToast, progress: undefined, toastId: "", })
            : toast.success(toastMessage, { position: "top-right", hideProgressBar: true, onClose: handleCloseToast, progress: undefined, toastId: "", })}
        
        </>
      )} */}
 
      <ToastContainer autoClose={3000} limit={1} />
      {bookingsSuccess ? (
        <div className="d-flex justify-content-center align-items-center">
          <Lottie
            animationData={Loader}
            loop={true}
            style={{ width: 300, height: 300 }}
          />
        </div>
      ) : (
        <div className="booking-detail-info">
          <div className="row">
            <div className="col-lg-12">
              <div className="booking-information-main">
                <form>
                  <div className="booking-information-card  ">

                    <div className="booking-info-body">
                      <div className="payment-method-types">
                        <p>Select Payment Method</p>

                        <ul className="booking-radio-btns">
                          <li>
                            <label className="d-flex gap-2 align-items-center">
                              <input
                                type="radio"
                                name="payment_type"
                                value="card"
                                checked={paymentType === "card"}
                                onChange={() => setPaymentType("card")}
                              />
                              <span className="">
                                <span className="d-flex gap-2 align-items-center">
                                  <ImageWithBasePath src={`assets/img/icons/payment-3.svg`} width={"40"} alt="Img" /> Card
                                </span>
                              </span>
                            </label>
                          </li>
                          <li>
                            <label className="d-flex gap-2 align-items-center">
                              <input type="radio" name="payment_type" value="cashapp"
                                onChange={() => setPaymentType("cashapp")}
                                checked={paymentType === "cashapp"}
                              />
                              <span className="d-flex gap-2 align-items-center">
                                <span className="d-flex gap-2 align-items-center">
                                  <ImageWithBasePath src={`assets/img/icons/cash-app.svg`} width={"40"} alt="Img" /> CashAPP</span>

                                {paymentType === "cashapp" &&
                                  <input type="text" value={selectedCashID} placeholder="Cashtag" onChange={(e) => {
                                    setSelectedCashID(e.target.value);
                                    setError(false);
                                  }} className={`form-control py-2 ${Error ? "is-invalid" : ""}`} />}

                              </span>
                            </label>
                          </li>
                          <li>

                            <label className="d-flex gap-2 align-items-center">
                              <input type="radio" name="payment_type" value="zelle"
                                onChange={() => setPaymentType("zelle")}
                                checked={paymentType === "zelle"}
                              />
                              <span className=" d-flex gap-2 align-items-center">
                                <span className="d-flex gap-2 align-items-center">
                                  <ImageWithBasePath src={`assets/img/icons/zelle.svg`} width={"40"} alt="Img" /> Zelle</span>

                                {paymentType === "zelle" && <input type="text" value={selectedZelleIdentifier} placeholder="Email or phone" onChange={(e) => {
                                  setSelectedZelleIdentifier(e.target.value);
                                  setError(false);
                                }} className={`form-control py-2 ${Error ? "is-invalid" : ""}`}

                                />}

                              </span>
                            </label>
                          </li>

                          <li>

                            <label className="d-flex gap-2 align-items-center">
                              <input type="radio" name="payment_type" value="other" onChange={() => setPaymentType("other")} checked={paymentType === "other"}
                              />
                              <span className="  w-100 d-flex gap-2 align-items-center">
                                <span className="d-flex gap-2 align-items-center px-2">
                                  <ImageWithBasePath src={`assets/img/icons/dollar.svg`} width={"30"} alt="Img" />
                                  <span className="ps-1"> Other </span></span>

                                {paymentType === "other" && <input type="text" value={customerNotes} placeholder="notes" onChange={(e) => {
                                  setCustomerNotes(e.target.value);
                                  setError(false);
                                }} className={`form-control py-2 ${Error ? "is-invalid" : ""}`} />}

                              </span>
                            </label>
                          </li>

                        </ul>



                      </div>


                      {paymentType === "card" && <>
                        <div>

                          <label className="w-100 payment_custom_check text-center pb-2">

                            <span className="payment_checkmark" >
                              <span className="checked-title" style={{
                                width: "50%"
                              }}>
                                <ImageWithBasePath
                                  src="assets/img/stripe-payment.png"
                                  alt="Img"
                                  width={"50"}
                                />
                              </span>
                            </span>
                          </label>

                        </div>

                        {savedCards.length > 0 && <div>
                          <p> Saved Cards</p>
                        </div>}

                        <div className="payment-method-types payments-cards-types">
                          <div className="row">
                            <div className="col-lg-7">
                              <ul>
                                {savedCards?.length > 0 ? (

                                  savedCards?.map((card: any) => (
                                    <li key={card.id}>
                                      <label className="payment_custom_check">
                                        <input
                                          type="radio"
                                          name="payment_card"
                                          id="debit_card"
                                          value={card.id}
                                          checked={selectedCard === card.id}
                                          onChange={() => {
                                            setSelectedCard(card.id);
                                            setNewCard(false);
                                          }}
                                        />
                                        <span className="payment_checkmark" style={{
                                          minHeight: 40
                                        }}>
                                          <span className="checked-title" style={{
                                            maxWidth: "20%"
                                          }}>
                                            <ImageWithBasePath
                                              src={`assets/img/icons/payment-${card.card.brand}.svg`}
                                              alt="Img"

                                            />
                                          </span>
                                          <small>
                                            {
                                              (card.card.brand || "Unknown").charAt(0).toUpperCase() + (card.card?.brand || "Unknown").slice(1)
                                            }

                                            <span>
                                              *********{card.card?.last4 || "*********"}
                                            </span>
                                          </small>
                                        </span>
                                      </label>
                                    </li>
                                  ))


                                ) : (
                                  <></>
                                )}


                              </ul>


                              <div className="py-1">
                                <label onClick={() => { handleAddNewCard() }} htmlFor="add_new_card" className="text-underline" >
                                  <u className="text-primary" style={{
                                    color: "#009FDF"
                                  }}> <i className="feather icon-plus fs-6" style={{
                                    color: "#009FDF"
                                  }} /> Add New Card </u>

                                </label>
                              </div>

                            </div>

                          </div>
                          {newCard && (
                            <div className="">
                              {loading ? (
                                <div className="d-flex justify-content-center">
                                  <Lottie
                                    animationData={Loader}
                                    loop={true}
                                    style={{ width: 100, height: 100 }}
                                  />
                                </div>
                              ) : reduxClientSecret ? (
                                <Elements
                                  stripe={stripePromise}

                                  options={{
                                    currency: 'usd',
                                    clientSecret: reduxClientSecret,
                                    appearance: {

                                      theme: 'stripe',
                                      variables: {
                                        colorPrimary: '#0d6efd',
                                        colorBackground: '#ffffff',
                                        colorText: '#30313d',
                                        colorDanger: '#df1b41',
                                        fontFamily: 'system-ui, sans-serif',
                                        spacingUnit: '4px',
                                        borderRadius: '4px',
                                      },
                                    },
                                    paymentMethodCreation: 'manual'
                                  }}
                                >
                                  <StripeCard ref={stripeCardRef} onCardSaved={onCardSaved}
                                  // bookingInfo={bookingInfo}
                                  />
                                </Elements>
                              ) : (
                                <p>Loading payment form...</p>
                              )}
                            </div>
                          )}
                        </div>


                        <div className="booking-info-btns d-flex justify-content-end pt-0">

 

                          <button
                            onClick={handleUseCard}
                            disabled={(!selectedCard && !newCard) || loading}
                            className="btn btn-primary mt-1"
                            type="button"
                          >
                            Pay ${initialPayment ?? 0} &amp; Place Reservation
                          </button>

 

                        </div>
                      </>}


                      {paymentType === "cashapp" && <>


                        {payoutAccountList?.length > 0 && <div>
                          <p> CashApp Accounts</p>
                        </div>}

                        <div className="payment-method-types payments-cards-types">
                          <div className="row">
                            <div className="col-lg-7">
                              <ul>
                                {payoutAccountList?.length > 0 ? (

                                  payoutAccountList?.map((card: any) => (
                                    <li key={card.id}>
                                      <label className="payment_custom_check">
                                        <input
                                          type="radio"
                                          name="payment_card"
                                          id="debit_card"
                                          value={card.id}
                                          checked={selectedCard === card.id}
                                          onChange={() => {
                                            setSelectedCard(card.id);
                                            setSelectedCashID(card?.cashapp_id);
                                            setNewCard(false);
                                          }}
                                        />
                                        <span className="payment_checkmark align-items-center py-0" style={{
                                          minHeight: 40
                                        }} >
                                          <span className="checked-title">
                                            <ImageWithBasePath
                                              src={`assets/img/icons/cash-app.svg`}
                                              alt="Img"

                                            />
                                          </span>
                                          <small>
                                            {
                                              (card?.cashapp_id || "Unknown").charAt(0).toUpperCase() + (card?.cashapp_id || "Unknown").slice(1)
                                            }


                                          </small>
                                        </span>
                                      </label>
                                    </li>
                                  ))


                                ) : (
                                  <></>
                                )}


                              </ul>


                              <div className="py-1 d-flex align-items-center">
                                <label>RefId: {bookingInfo?.bookings?.reference_id}</label>
                              </div>
                              <div className="py-1">
                                <p className="text-justify">
                                  After submission, our team will send a payment request. Please complete the payment and notify us once done.
                                </p>
                              </div>




                            </div>

                          </div>
                          {newCard && (
                            <div className="">
                              {loading ? (
                                <div className="d-flex justify-content-center">
                                  <Lottie
                                    animationData={Loader}
                                    loop={true}
                                    style={{ width: 100, height: 100 }}
                                  />
                                </div>
                              ) : (
                                <>


                                  <div className="py-1 d-flex align-items-center">

                                    <label>RefId: {bookingInfo?.bookings?.reference_id}</label>


                                  </div>
                                  <div className="py-1">
                                    <p className="text-justify">
                                      After submission, our team will send a payment request. Please complete the payment and notify us once done.
                                    </p>

                                  </div>

                                </>
                              )}



                            </div>
                          )}

                          <div className="booking-info-btns d-flex justify-content-end pt-0">
 

                            <button
                              onClick={handleConfirm}
                              // disabled={(!selectedCard && !newCard) || loading}
                              className="btn btn-primary "
                              type="button"
                            >
                              Pay ${initialPayment ?? 0} &amp; Place Reservation
                            </button>

 
                          </div>
                        </div>

                      </>}


                      {paymentType === "zelle" && <>


                        {payoutAccountList?.length > 0 && <div>  <p> Zelle Accounts</p>  </div>}

                        <div className="payment-method-types payments-cards-types">
                          <div className="row">
                            <div className="col-lg-7">
                              <ul>
                                {payoutAccountList?.length > 0 ? (

                                  payoutAccountList?.map((card: any) => (
                                    <li key={card.id}>
                                      <label className="payment_custom_check">
                                        <input
                                          type="radio"
                                          name="payment_card"
                                          id="debit_card"
                                          value={card.id}
                                          checked={selectedCard === card.id}
                                          onChange={() => {
                                            setSelectedCard(card.id);
                                            setSelectedZelleIdentifier(card?.zelle_identifier);
                                            setNewCard(false);
                                          }}
                                        />
                                        <span className="payment_checkmark align-items-center py-0" style={{
                                          minHeight: 40
                                        }}  >
                                          <span className="checked-title">
                                            <ImageWithBasePath
                                              src={`assets/img/icons/zelle.svg`}
                                              alt="Img"
                                            />
                                          </span>
                                          <small>
                                            {
                                              (card?.zelle_identifier || "Unknown").charAt(0).toUpperCase() + (card?.zelle_identifier || "Unknown").slice(1)
                                            }
                                          </small>
                                        </span>
                                      </label>
                                    </li>
                                  ))


                                ) : (
                                  <></>
                                )}


                              </ul>



                            </div>

                          </div>


                          <>

                            <div className="py-1 d-flex align-items-center" >
                              <label>RefId: {bookingInfo?.bookings?.reference_id}</label>
                            </div>
                            <div className="py-1">
                              <p className="text-justify">
                                After submission, our team will send a payment request. Please complete the payment and notify us once done.
                              </p>
                            </div>
                          </>


                          <div className="booking-info-btns d-flex justify-content-end pt-0">
 


                            <button onClick={handleConfirm}

                              className="btn btn-primary" type="button"    >
                              Pay ${initialPayment ?? 0} &amp; Place Reservation
                            </button>
                          </div>

 

                        </div>

                      </>}


                      {paymentType === "other" && <>
                        <div className="payment-method-types payments-cards-types">
                          <>
                            <div className="py-1 d-flex align-items-center" >
                              <label>RefId: {bookingInfo?.bookings?.reference_id}</label>
                            </div>
                          </>

                          <div className="booking-info-btns d-flex justify-content-end pt-0">
 
                            <button onClick={handlePaylater} disabled={otherPaymentLoading} className="btn btn-primary" type="button"   >
                              Pay later
                            </button>

 

                          </div>

                        </div>

                      </>}


                    </div>
                  </div>

                </form>
              </div>
            </div>
          </div>





        </div>
      )}
    </div>
  );
};

export default BookingPayment;